import { Link } from "react-router-dom";

/**
 * Subtle "you're looking at sample data" banner shown on every dashboard
 * page when period.hasRealData is false (no MetricDaily rows exist yet).
 *
 * Non-blocking: the page below renders normally with placeholder numbers.
 * This is a hint, not a gate — brand-new clients shouldn't see a scary
 * empty-state wall before their first sync.
 */
export function SampleDataBanner() {
  return (
    <div
      role="status"
      className="flex items-center gap-3 rounded-card border border-border-default bg-surface px-4 py-2.5"
    >
      <span
        aria-hidden="true"
        className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-accent-bg border border-accent-border text-accent font-semibold text-[10px] flex-shrink-0"
      >
        i
      </span>
      <div className="flex-1 min-w-0 text-[12px] text-text-secondary">
        <span className="font-medium text-text-primary">Sample data.</span>
        {" "}No synced metrics yet — numbers below are illustrative.
      </div>
      <Link
        to="/account"
        className="text-[12px] text-accent hover:underline font-medium flex-shrink-0"
      >
        Sync now →
      </Link>
    </div>
  );
}
